"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebPImage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const WebPImage_module_css_1 = __importDefault(require("./WebPImage.module.css"));
/**
 *
 */
function WebPImage({ url, fallbackUrl, alt, objectFit, borderRadiusAsString }) {
    const style = {
        ...(Boolean(objectFit) && {
            objectFit,
        }),
        ...(Boolean(borderRadiusAsString) && {
            borderRadius: borderRadiusAsString,
        }),
    };
    return ((0, jsx_runtime_1.jsxs)("picture", { className: WebPImage_module_css_1.default.image, style: style, children: [(0, jsx_runtime_1.jsx)("source", { type: "image/webp", srcSet: url }), (0, jsx_runtime_1.jsx)("img", { src: fallbackUrl || url, alt: alt, style: style })] }));
}
exports.WebPImage = WebPImage;
//# sourceMappingURL=WebPImage.js.map